module.exports = __webpack_public_path__ + "img/jiangxiligong.8a2e5e3d.png";